import { LandingpageService, PublicationPublicPreview } from "../client"

/* Interfaces & Types */
export type PublicationPreviewProps = {
  publication: PublicationPublicPreview
}

export type PublicationCarouselPreviewProps = {
  publications: PublicationPublicPreview[]
}


/* ENDPOINTS */
export const getLandingpage = () => {
    return {
        queryFn: async () => {
            const data = await LandingpageService.readLandingpage()
            return data ?? { data: null, count: 0 }
        },
        queryKey: ["landingpage"],
    }
}